export default __webpack_public_path__ + "static/media/2_0078.235c3543.webp";